import React, { useState } from 'react'
import { Homelogo, mobileImg1, mobileImg2, sermon1, Verse1, Verse2, Verse2026_1, Verse2026_2, Verse22026_3, Verse3 } from '../../constants/imageConstants';
import { TfiAlarmClock } from "react-icons/tfi";
import { TbCross } from "react-icons/tb";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import {IoIosArrowBack,IoIosArrowForward} from 'react-icons/io';
import { whatsapp_id, youtube_id } from '../../constants/themeConstants';


function Home() {

  const sunday_services = [
    {
        name:'Holy Sunday Service',
        description:'Every Sunday (Tamil and Kannada Service)',
        timing:'09:30 AM',
        image:''
    },
    {
        name:'Children Ministry',
        description:'',
        timing:'12:00 Noon',
        image:''
    },
    {
        name:'Youth Ministry',
        description:'',
        timing:'12:30 PM Onwards ',
        image:''
    },
    {
        name:'Holy Sunday Kannada Service',
        description:'',
        timing:'07:00 PM',
        image:''
    },
  ]

  const images = [
    Homelogo,
    Verse2026_1,
    Verse2026_2,
    Verse22026_3,
    Verse1,
    Verse2,
    Verse3
  ]

  return (
    <div>
      {/* <div className='relative md:min-h-[94vh] w-screen md:max-h-[94vh]'>
         <img src={Homelogo} alt="Homelogo" className='md:min-h-[94vh] w-screen md:max-h-[94vh] object-cover'/>  
          <div className='bg-black/40 absolute top-0 left-0 md:min-h-[94vh] w-screen md:max-h-[94vh]'>
          </div>
      </div> */}

      <div className='relative z-10'>
          <Carousel 
            centerMode={true} 
            autoPlay={true} 
            showStatus={false}
            showThumbs={false}
            showArrows={true}
            swipeable={true}
            autoFocus={true}
            interval={5000}
            centerSlidePercentage={100}
            showIndicators={false}
            className='relative bg-red-100 -z-0'
          
            
            
            renderArrowPrev={(clickHandler, hasPrev) => {
              return (
                <div
                  className={`${hasPrev ? "opacity-100" : "opacity-20"} absolute right-[35px] z-100 border-r-2 border-gray-100 bottom-0 bg-white  flex justify-center items-center p-2  cursor-pointer z-20`}
                  onClick={clickHandler}
                >
                  <IoIosArrowBack size={20} className="text-black" />
                </div>
              );
            }}
            renderArrowNext={(clickHandler, hasPrev) => {
              return (
                <div
                  className={`${hasPrev ? "opacity-100" : "opacity-20"} absolute right-0 bottom-0 bg-white  flex justify-center items-center p-2  cursor-pointer z-20`}
                  onClick={clickHandler}
                >
                  <IoIosArrowForward size={20} className="text-black" />
                </div>
              );
            }}
          
          >
              {images?.map((c,i)=>(
                  <div className='text-center  w-[100%] h-[35vh] md:h-[95vh]  overflow-auto  mx-auto focus:outline-none focus:ring-0'>
                      <img src={c}  className='w-full  relative h-[35vh] md:h-[95vh] object-stretch md:object-stretch focus:outline-none focus:ring-0 '/>
                  </div>    
              ))}
          </Carousel>
      </div>    



      <div className='bg-violet-100 h-[622px] md:h-[250px] md:mt-[100px] py-5'>
        
        <div className='relative w-[80%] mx-auto'>

          <div className='md:w-[70%] md:pt-8'>
            <h6 data-aos="fade-right" className='text-[15px] font-heading'>Stand firm in faith, even when the world trembles.
              Let love be your language, and Christ your strength.
              For those who walk with God,
              Never walk alone.</h6>
              <h6 data-aos="fade-right" className='text-[15px] font-heading my-2'>Draw near to God each day,
              Listen to His gentle whisper,
              Walk in obedience and truth,
              For His plans are greater than our own.</h6>

              <h6 data-aos="fade-up" className='text-[18px] text-[#7b026b] font-heading mb-2'> Rev K. Selvaraj</h6>

          </div>
          <div data-aos="fade-up">
          <img src={sermon1} alt={sermon1} className='absolute z-1 right-0 md:-top-[293px] h-[350px]' />
          </div>
        </div>

      </div>
    
        <div className=' w-[80%] py-16 relative mx-auto'>

           <TbCross data-aos="fade-down" size={200} className='absolute left-[40%] top-10 opacity-40 text-black/10' />
            <div>
                <h1 data-aos="fade-right" className='text-[20px] font-heading'>Need Prayer?</h1>
                <div data-aos="fade-right" className='bg-[#7b026b]/10 p-2'>
                <h1 className='text-[15px] text-[#7b026b] w-[100%] font-thicker'>“ಆತ್ಮನಿಂದ ಪ್ರೇರಿತರಾಗಿ ಎಲ್ಲಾ ಸಂದರ್ಭಗಳಲ್ಲಿಯೂ ಎಲ್ಲಾ ವಿಧದ ಪ್ರಾರ್ಥನೆಗಳನ್ನೂ ವಿನಂತಿಗಳನ್ನೂ ಮಾಡಿ.
                ಈ ವಿಷಯದಲ್ಲಿ ಜಾಗರೂಕರಾಗಿ, ಎಲ್ಲಾ ದೇವರ ಜನರ ನಿಮಿತ್ತ ಸದಾಕಾಲ ಪ್ರಾರ್ಥಿಸುತ್ತಿರಿ.”</h1>
                <h6 className='flex items-center justify-end text-[14px] font-heading my-2 mr-10'>ಎಫೆಸಿಯನರಿಗೆ 6:18</h6>
                </div>
                <h4 data-aos="fade-left" className='text-[16px] my-2 font-body'>You are not alone. A <span className='font-heading'>IGPH Kamalanagar</span> devoties are ready to pray for you right now. Share your prayer request below, and someone will get in contact with you.</h4>
            </div>
            <div onClick={()=>window.open(whatsapp_id,'_blank')} data-aos="fade-up" className='flex  mt-2 md:mt-0 items-center justify-end'>
              <h6 className='bg-gray-100 cursor-pointer transition-all duration-500 w-max  text-[14px] 2xl:text-[17px] text-center px-2 py-1 font-body hover:bg-black hover:text-white'>Request For Prayer</h6>
            </div>
        </div>

        
        <div data-aos="fade-up" className='bg-slate-800 relative md:mb-24 flex items-center justify-center px-5 py-10'>
          <TfiAlarmClock size={80} className='text-white opacity-40 animate-bounce absolute top-[5px] md:top-[100px] left-[10px]' />
          <div>
            <h6 className='text-[18px] text-[#c934b6] text-center font-heading uppercase'>Join Us This Sunday</h6>
            <h6 className='text-[16px] font-body text-center text-white'>To Worship all might <span className='font-heading'>GOD</span> together</h6>
            
           
            <div data-aos="fade-right" className='grid grid-cols-2 md:grid-cols-4 border border-slate-600   my-4 '>
              {sunday_services?.map((s)=>(
                <div className='border-r border-b md:border-b-0 border-slate-600 p-4'>
                    <h6 className='font-heading text-[15px] text-center text-white'>{s?.name}</h6>
                    <h6 className='font-body text-[#c934b6] text-[13px] text-center'>{s?.timing}</h6>
                </div>  
              ))}
            </div>



            <div data-aos="fade-down" className='flex my-4 items-center justify-center'>
              <div onClick={()=>window.open("https://www.google.com/maps?ll=12.992706,77.527838&z=11&t=m&hl=en-US&gl=US&mapclient=embed&cid=7752176074924499455",'_blank')} className='bg-green-500 hover:bg-green-700 cursor-pointer mx-4 text-white w-max px-2 py-1 font-body text-[14px]'>
                <h6>Visit Church</h6>
              </div>

              <div onClick={()=>window.open(youtube_id,'_blank')} className='bg-red-500 hover:bg-red-700 cursor-pointer  mx-4 text-white w-max px-2 py-1 font-body text-[14px]'>
                <h6>Watch Online</h6>
              </div>
            </div>

          </div>
        </div>
       
       {/* {cookie && (
        <div
          className={`fixed bottom-0 w-full px-5 py-4 text-center flex items-center justify-between text-white bg-black/90
            transition-all duration-300 ease-in-out
            ${closing ? 'opacity-0 translate-y-10' : 'opacity-100 translate-y-0'}`}
        >
          <h6 className='text-[12px]'>
            This website utilizes technologies such as cookies to enable essential site functionality, as well as for analytics, personalization, and targeted advertising. To learn more, view the following link:{' '}
            <span onClick={()=>navigate('privacy_policy')} className='underline font-[600] cursor-pointer'>Privacy Policy</span>
          </h6>
          <IoIosClose onClick={handleClose} size={30} className='cursor-pointer' />
        </div>
      )} */}


      <div className='bg-[#7b026b]/20 h-[600px] md:h-[265px] md:mb-20 p-4'>
         <div className='md:flex relative w-[90%] md:w-[80%] mx-auto'>
         <div className='md:w-[50%] mt-4'>
          <h6 data-aos="fade-right" className='text-[20px] font-heading tracking-widest'>Download Song App</h6>
          <h6 data-aos="fade-right" className='text-[12px] text-[#7b026b] font-heading'>Stuthi Aaradhane Geethegalu</h6>
          <h6 data-aos="fade-right" className='text-[14px] my-2 font-body'>Discover the timeless beauty of Stuthi Aaradhane Geethegalu, the sacred songbook of praise and worship to God and Jesus Christ.<br></br>
            Whether you’re seeking comfort, strength, or inspiration, the Book of Stuthi Aaradhane Geethegalu offers powerful verses that speak directly to the soul.</h6>
          <div data-aos="fade-up" className='flex mt-5'>
            <div className='flex mr-4 mt-2 md:mt-0 items-center justify-end'>
              <h6 onClick={()=>window.open('https://play.google.com/store/apps/details?id=com.igph.Psalms','_blank')} className='cursor-pointer transition-all duration-500 w-max  text-[12px] 2xl:text-[17px] text-center px-2 py-1 font-body bg-black text-white'>Download App</h6>
            </div>

            <div className='flex  mt-2 md:mt-0 items-center justify-end'>
              <h6 onClick={()=>window.open("https://docs.google.com/forms/d/e/1FAIpQLSfUGI6jDJ3z087TeSxLABQHztwhlFjfydoz_egYscjB7THjEQ/viewform",'_blank')} className='bg-gray-100 cursor-pointer transition-all duration-500 w-max  text-[12px] 2xl:text-[17px] text-center px-2 py-1 font-body hover:bg-black hover:text-white'>Buy Book</h6>
            </div>

          </div>
         </div>

         <div className='md:h-[250px] flex'>
          <img data-aos="fade-down" src={mobileImg2} className='w-[140px] md:w-[175px] absolute right-[60%] mt-5 md:mt-0  md:right-[18%] md:-top-24' alt={mobileImg2} />
          <img data-aos="fade-up" src={mobileImg1} className='w-[140px] md:w-[175px] absolute right-[12%] mt-2 md:mt-0 md:right-2 md:-bottom-20' alt={mobileImg1} />
         </div>
         </div>
      </div>
    </div>
  )
}

export default Home